export default "__VITE_ASSET__BvuBSibr__"